export const UPDATE_IMAGE='UPDATE_IMAGE'
export const UPDATE_IMAGE_SUCCESS= 'UPDATE_IMAGE_SUCCESS'
export const UPDATE_IMAGE_ERROR= 'UPDATE_IMAGE_ERROR'

export const UpdateImage= (data) => ({
    type: UPDATE_IMAGE,
    payload: data
})

